import React from 'react';
import { FadeIn } from './FadeIn';
export function ProblemSection() {
  return <section className="bg-[#F5F5F5] py-10 md:py-16 px-4 md:px-8" data-id="element-109">
      <div className="max-w-4xl mx-auto text-center" data-id="element-110">
        <FadeIn data-id="element-111">
          <h2 className="text-2xl md:text-4xl font-bold text-gray-900 mb-3 md:mb-5 leading-tight" data-id="element-112">
            ¿Llegás a las 8 PM cansado y terminás pidiendo delivery de nuevo?
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-113">
          <p className="text-lg md:text-xl text-gray-700 leading-relaxed" data-id="element-114">
            Sabemos lo que sentís. El agotamiento de trabajar todo el día, abrir
            la heladera y ver ingredientes sueltos pero nada listo para comer.
            Terminás gastando una fortuna en comida rápida que te inflama y te
            quita energía. Estás tirando plata y salud por falta de un sistema.
          </p>
        </FadeIn>
      </div>
    </section>;
}